import React from 'react';
import parse from 'html-react-parser';

export default function PageDetailDescription({ data }) {
    return (
        <main>
            <h4 style={{ color: "#333333" }}>Deskripsi</h4>
            <div style={{ textAlign: "justify" }}>
                {parse(data.description)}
            </div>
            <div className="row" style={{ marginTop: 30 }}>
                {Array.isArray(data.featureId) &&
                data.featureId.map((feature, index) => (
                <div
                    key={`feature-${index}`}
                    className="col-3 text-center d-flex flex-column align-items-center justify-content-center"
                    style={{ marginBottom: 20, color: "#696969" }}
                >
                    <img
                    width="38"
                    src={`${process.env.REACT_APP_HOST}/images/${feature.imageUrl}`}
                    alt={feature.name}
                    className="d-block mb-2"
                    />
                    <span className="text-gray-500 fw-light">
                    {feature.qty > 1 ? feature.qty : ""} {feature.name}
                    </span>
                </div>
                ))}
            </div>
        </main>
    )
}
